import { apiBaseUrl } from "../config";

const cacheBust = Math.random().toString(36).substring(2);

export function createCustomWebViewUrl(
    url: string,
    applyDefaultQueryParams: boolean,
    deviceId: string | undefined,
    auth: string,
    groupId?: string | undefined,
    status?: string | undefined,
    moduleName?: string | undefined,
    configurationFileId?: string,
) {
    let currentUrl = url;

    if (applyDefaultQueryParams) {
        const urlParsed = new URL(currentUrl);
        if (urlParsed.search === "") {
            urlParsed.search = `?module={module}&device={device_id}&auth={auth}&configuration={configuration}`;
            urlParsed.search += `&formant_url=${encodeURIComponent(
                apiBaseUrl,
            )}`;
            currentUrl = urlParsed.toString();
        }
    }

    return currentUrl
        .replace("{device_id}", deviceId ?? "")
        .replace("{auth}", auth ?? "")
        .replace("{group_id}", groupId ?? "")
        .replace("{module}", moduleName ?? "")
        .replace("{status}", status?.toLowerCase() ?? "all")
        .replace("{cache_bust}", cacheBust)
        .replace("{configuration}", configurationFileId ?? "");
}
